import { render, staticRenderFns } from "./SafeReportingIncident.vue?vue&type=template&id=158bfd82&"
import script from "./SafeReportingIncident.vue?vue&type=script&lang=js&"
export * from "./SafeReportingIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports